import settings from '@/settings'

const ContratoEmpresa = (headers, data) => {
    const parametros = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }
    if (data.method === 'POST') parametros.body = JSON.stringify(data)
    else parametros.cache = 'default'
    return fetch(`${settings.apetrusApi}/configuracoes/faturamento/empresa/`, parametros)
}

const ContratoPosto = (headers, data) => {
    const parametros = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }
    if (data.method === 'POST') parametros.body = JSON.stringify(data)
    else parametros.cache = 'default'
    return fetch(`${settings.apetrusApi}/configuracoes/faturamento/posto/`, parametros)
}

const versaoApp = (headers, data) => {
    const parametros = {
        method: data.method,
        mode: 'cors',
        headers: headers
    }
    if (data.method === 'POST') parametros.body = JSON.stringify(data)
    else parametros.cache = 'default'
    return fetch(`${settings.apetrusApi}/configuracoes/versaoapp/`, parametros)
}

export default {
    ContratoEmpresa,
    ContratoPosto,
    versaoApp
}
